// A stable, random per-browser id sent in `hello` and as the bearer for GET /api/replays — how a player
// finds their own replays across sessions. localStorage on purpose (unlike tokenStore.ts's per-tab session
// token): every tab of one browser is the same player here, and nothing is displaced by sharing it. Falls
// back to sessionStorage, then to memory, where storage throws (some private-browsing modes).
import { isValidPlayerKey } from '../../shared/protocol.js';

const KEY = 'bestiarum-player-key';

export type KeyStorage = Pick<Storage, 'getItem' | 'setItem'>;

let memoryKey: string | null = null;

function newPlayerKey(): string {
  let bin = '';
  for (const b of crypto.getRandomValues(new Uint8Array(16))) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function playerKey(candidates: (() => KeyStorage)[] = [() => localStorage, () => sessionStorage]): string {
  for (const storage of candidates) {
    try {
      const s = storage();
      const existing = s.getItem(KEY);
      if (isValidPlayerKey(existing)) return existing;
      const fresh = newPlayerKey();
      s.setItem(KEY, fresh);
      return fresh;
    } catch { /* this storage is unavailable, try the next */ }
  }
  return (memoryKey ??= newPlayerKey());
}
